// extracted by LIB_CSS_EXTRACT_LOADER
import "./separator_module.css"
export default {"separator":"separator-nT9Ebz","horizontal":"horizontal-hYZGwW","vertical":"vertical-qQKpma"};